module.exports = __webpack_public_path__ + "img/c03_unitslingerchampion_Normal_ua.240569de.webp";